/* eslint-disable max-len */
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";
import { IWellnessModalStatus, wellnessModalStatusActions } from "../../../state/wellnessModalStatus";

export const useWellnessModalStatusStore = () => {
  const dispatch = useDispatch();
  const { showWellnessUpsell } = useSelector((state: IRootState) => state.wellnessModalStatus as IWellnessModalStatus);

  const setShowWellnessUpsell = (showModal: boolean) => {
    dispatch(wellnessModalStatusActions.setShowWellnessUpsell(showModal));
  };


  return {
    setShowWellnessUpsell,
    showWellnessUpsell,
  };
};

export default useWellnessModalStatusStore;

